import React from 'react'
import { BsArrowRight } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import './Home.css'
const Home = () => {
  const navigate = useNavigate()
  return (
    <div className='container container_light home'>
      <AuthenticatedRoutes auth={true} />
      <div className='logo'>
        <img src='/assets/images/logo.png' alt='' />
        <h3>RROWHEAD</h3>
      </div>
      <div className='content'>
        <h1>Get Arrowhead for Chrome</h1>
        <p>
          Get transcripts, action items and summaries automatically post your
          call
        </p>
        <img
          src='https://s3-alpha-sig.figma.com/img/e2b6/5dc8/b674ac021380bb76b5996a7b05cc73bb?Expires=1678060800&Signature=XC8RUVfOcQ1r5eBTVsqTKA~zUHuulrbZqaNQDP2U0R8TAYN8zMGXjwRFyVa8agsdhGT0hQ0YqHWs6ya2IshdC3K2ZJFKr~2kMf~I9MSGbbkkMuyzED5lH40gcnzZSd7EYMHuYHbLukReDUehakYA0~GMWLPwBJfcgs~tSi1QXnkq81bUulFjoqGQlu-JSXPbx~MdxHDs9KHPeab2Ihpk0rGp0IQhf0gWzTuI4bh2NprT~c8XMlKIWz8XUkdRoMqPZbt2nbq3Rs0DbAdgpdUz63nYS2Y2563KS5AiwVRjazhZ3ZEKIr7rxGUvWkNgyjnGQT3V1htEIP3FNIZOgUxHjA__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4'
          alt=''
        />
        <button
          onClick={() => {
            window.open(
              'https://chrome.google.com/webstore/detail/arrowhead/pdbahohfckjamlffhjfkbgmbhbkkiama'
            )
            navigate('/signin-success')
          }}
        >
          Download now from Chrome store
          <BsArrowRight size={14} style={{ marginLeft: '5px' }} />
        </button>
        <span
          onClick={() => {
            navigate('/confirm')
          }}
        >
          I don’t want the optimal experience - download later
        </span>
      </div>
    </div>
  )
}

export default Home
